import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import Row from "../../Structure/Row";
import Input from "../../Input";
import Column from "../../Structure/Column";
import DatePicker from "../../DatePicker";
import FilePreview from "../../FilePreview";
import Group from "../../Structure/Group";
import Button from "../../Button";
import ModalConstructor from '../ModalConstructor';
import { prepareModalData } from '../../../utils/prepareModalData';
import { prepareDateToSee } from '../../../utils/dates';
import { API_getReports, API_getReportsEditAndDeleteUrl, API_URL_GET_REPORTS_SET_POSITIONS } from '../../../utils/api';
import { validateRegexpNumberFunction } from '../../../utils/validateRegexpNumberFunction';

const EditUPRecordModal = (props) => {
  const { item, isEditable, hideModal, appendAfterId, allIds, constructionCertificateId } = prepareModalData(props);
  const itemId = item.id;

  const getFetchRequestUrl = useCallback((isEditable) => {
    const requestUrl = isEditable ?
      API_getReportsEditAndDeleteUrl(itemId) :
      API_getReports();

    return requestUrl;
  }, [isEditable, itemId]);

  const editProps = {
    name: {
      required: true,
      value: item.name || '',
      errorText: '',
    },
    number: {
      required: true,
      value: item.number || '',
      errorText: '',
      validateFunction: validateRegexpNumberFunction,
      validateFunctionErrorText: 'Значение должно соответствовать формату xx.yy'
    },
    closing_date: {
      required: false,
      value: item.closing_date || '',
      errorText: '',
      isDate: true,
    },
    presentations: {
      required: false,
      value: item.presentations || '',
      errorText: '',
      isDate: true,
    },
    current_documentation: {
      required: false,
      value: item.current_documentation || '',
      errorText: '',
    },
    files: {
      required: false,
      value: item.files || [],
      errorText: '',
      isFile: true,
    },
    construction_certificate_id: {
      value: constructionCertificateId,
      needToSendAlways: true,
    },
  };

  const getTemplate = (templateProps) => {
    const {
      fieldsData,
      submitButtonText,
      handleForm,
      handleFileInput,
      handleFileDelete,
      onCloseAction,
      onSubmitAction,
    } = templateProps;

    const getFieldProps = (name) => {
      return {
        name,
        value: fieldsData[name].value,
        required: fieldsData[name].required,
        errorText: fieldsData[name].errorText,
      };
    };

    const onFileLoadHandler = (files) => {
      handleFileInput({ files, itemId, fileKeyInState: 'files' });
    };

    const onFileDeleteHandler = (file) => {
      handleFileDelete({ file, fileKeyInState: 'files' });
    };

    return (
      <>
        <Row>
          <Input
            placeholder='Введите номер рапорта/извещения'
            label='Номер рапорта/извещения'
            onChange={handleForm}
            {...getFieldProps('number')}
          />
        </Row>
        <Row>
          <Input
            placeholder='Введите наименование'
            label='Наименование'
            onChange={handleForm}
            {...getFieldProps('name')}
          />
        </Row>
        <Row>
          <Input
            placeholder='Действующая документация УШ'
            label='Действующая документация'
            onChange={handleForm}
            {...getFieldProps('current_documentation')}
          />
        </Row>
        <Row direction='row'>
          <Column>
            <DatePicker
              label='Дата закрытия'
              onChange={handleForm}
              name='closing_date'
              calendarValue={fieldsData.closing_date.value}
              displayedValue={prepareDateToSee(fieldsData.closing_date.value)}
              required={fieldsData.closing_date.required}
              errorText={fieldsData.closing_date.errorText}
            />
          </Column>
        </Row>
        <Row>
          <FilePreview onLoad={onFileLoadHandler} files={fieldsData.files.value} onDelete={onFileDeleteHandler} />
        </Row>
        <Group align='right'>
          <Button label='Закрыть' theme='hollow' onClick={onCloseAction} />
          <Button label={submitButtonText} onClick={onSubmitAction} />
        </Group>
      </>
    );
  };

  const editModalProps = {
    fieldsData: editProps,

    getFetchRequestUrl,
    getTemplate,

    hideModal,
    isEditable,

    SAVE_FILES_MODEL_TYPE: 'reports',

    appendAfterId,

    ALL_OBJECT_IDS: allIds,
    SET_POSITIONS_URL: API_URL_GET_REPORTS_SET_POSITIONS,
  };


  return <ModalConstructor {...editModalProps} />
};

EditUPRecordModal.propTypes = {
  hideModal: PropTypes.func.isRequired,
};

export default EditUPRecordModal;